module.exports = __webpack_public_path__ + "img/saum_tiefschwarz_ral9005.c83e4627.jpg";